import { createI18n } from 'vue-i18n'
import { Locale } from 'vant'
import jaJP from 'vant/es/locale/lang/ja-JP'
import enUS from 'vant/es/locale/lang/en-US'
import en from '../locales/en.json'
import ja from '../locales/ja.json'

function getDefaultLocale(): string {
  const lang = navigator.language || navigator.languages?.[0] || 'en'
  return lang.startsWith('ja') ? 'ja' : 'en'
}

const locale = getDefaultLocale()

if (locale === 'ja') {
  Locale.use('ja-JP', jaJP)
} else {
  Locale.use('en-US', enUS)
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale,
  fallbackLocale: 'en',
  messages: {
    en,
    ja,
  },
})

export default i18n
